import React, { Component } from "react";
// @material-ui/core components
import { withStyles } from "@material-ui/core/styles";

import withMobileDialog from "@material-ui/core/withMobileDialog";
import RecordPagination from '../../utils/RecordsPagination';

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

// material icons
import Approve from "@material-ui/icons/Done";
import Decline from "@material-ui/icons/Close";


import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  TableFooter,
  Grid,
} from "@material-ui/core";
import { appHelpers } from "../../_helpers";
import {appConstants} from "../../_constants";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  input: {
    marginTop: "0 !important"
  },
  nb: {
    color: "red",
    fontSize: "12px"
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: "67%"
  },
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    width: "100%"
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  },
  searchButton: {
    backgroundColor: " #66bb6a"
  },
  airlineSelect: {
    marginTop: "0px",
    width: '100%'
  },
  icon: {
    margin: "8px 0px 8px 0px",
    position: "relative",
    top: "7px",
    paddingLeft: "8px",
  }
});

const CustomTableCell = withStyles(theme => ({
  head: {
    color:  appConstants.REGIONAL_COLOR,
    fontSize: "14px",
    fontWeight: "lighter"
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

function ReconciliationTableStructure(props) {
  const { classes, reconciliationData, filterAirlines, filterUsers,
    filterStatus, approveReconciliation, declineReconciliation,
    handleChange, error, formError, disabled,
    isCommentModalOpen, openCommentModal, closeCommentModal, comment, processName,filterAirport } = props


  return (

    <div>

      {/* Comments Modal */}
      < Dialog
        fullWidth={true}
        maxWidth={'md'}
        open={isCommentModalOpen}
        onClose={closeCommentModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: appConstants.REGIONAL_COLOR}}>
          <span style={{ color: "white", textTransform: "uppercase" }}> Add Comment</span>
        </DialogTitle>
        <DialogContent style={{ marginTop: "20px" }}>
          <Grid container spacing={24}>

            <Grid item md={12} xs={12}>
              <CustomInput
                className={classes.input}
                required
                labelText="Comments"
                id="comment"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={
                  {
                    name: "comment",
                    type: "text",
                    value: comment,
                    onChange: handleChange,
                  }}
              />
              {error && <span style={{ color: 'red' }}>{formError}</span>}
            </Grid>

          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeCommentModal} color="danger">
            Cancel
          </Button>
          <Button disbled={disabled} onClick={() => (processName === "Approve") ? approveReconciliation() : declineReconciliation()} color="success" autoFocus>
            {processName}
          </Button>
        </DialogActions>
      </Dialog >

      {/* Edit Reconciliation Modal */}



      <div className={classes.tableResponsive}
       style={{ overflowX: "auto" }}>
        <Table className={classes.table} aria-labelledby="tableTitle">
          <TableHead className={classes.negativeColor} color="primary">
            <TableRow>
              {/* <TableCell >S/No</TableCell> */}
              <CustomTableCell >Airline <br /> Name</CustomTableCell>
              <CustomTableCell >Airport <br /> Name</CustomTableCell>
              <CustomTableCell >Amount</CustomTableCell>
              {/* <CustomTableCell >Token <br /> Rate (&#36;)</CustomTableCell> */}
              <CustomTableCell >Currency</CustomTableCell>
              <CustomTableCell >Narration</CustomTableCell>
              <CustomTableCell >Created <br /> By</CustomTableCell>
              <CustomTableCell >Created <br /> Date</CustomTableCell>
              <CustomTableCell >Processed <br /> By</CustomTableCell>
              <CustomTableCell >Processed <br /> Date</CustomTableCell>
              <CustomTableCell >Is <br /> Credit</CustomTableCell>
              <CustomTableCell >Status</CustomTableCell>
              <CustomTableCell >Comments</CustomTableCell>
              <CustomTableCell >Actions</CustomTableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {reconciliationData.map((item, key) => {
              return (
                <TableRow hover key={item.Id}>
                  {/* <TableCell >{key + 1}</TableCell> */}
                  <TableCell >{filterAirlines(item.AirlineId)}</TableCell>
                    {/*filterAirport*/}
                  <TableCell>{filterAirport(item.AirportCode)}</TableCell>
                  <TableCell >{appHelpers.numberWithCommasOnly(item.Amount)}</TableCell>
                  <TableCell > {item.CurrencyCode}</TableCell>
                  <TableCell >{item.Narration}</TableCell>
                  <TableCell >{filterUsers(item.CreatedBy)}</TableCell>
                  <TableCell >{(item.CreatedDate) ? appHelpers.formatDate(item.CreatedDate, "MMM DD, YYYY") : ""}</TableCell>
                  <TableCell >{filterUsers(item.ProcessedBy)}</TableCell>
                  <TableCell >{(item.ProcessDate) ? appHelpers.formatDate(item.ProcessDate, "MMM DD, YYYY") : ""}</TableCell>
                  <TableCell >{(item.Iscredit) ? "Yes" : "No"}</TableCell>
                  <TableCell >{filterStatus(item.Status)}</TableCell>
                  <TableCell >{(item.Comments ? item.Comments : "")}</TableCell>
                  {item.Status === 0 && <TableCell >
                    <span
                      onClick={() => openCommentModal(item.Id, "Approve")}
                      style={{ cursor: "pointer", color: "#43a047", padding: "0 5px" }}
                    >
                      <span className={classes.icon}><Approve /></span>
                    </span>
                    <span
                      onClick={() => openCommentModal(item.Id, "Decline")}
                      style={{ cursor: "pointer", color: "#dd2735", padding: "0 5px" }}
                    >
                      <span className={classes.icon}><Decline /></span>
                    </span>
                  </TableCell>}

                  {item.Status === 1 && <TableCell>
                    <span
                      style={{
                        cursor: "pointer", backgroundColor: "#43a047",
                        borderRadius: "5px", padding: "5px 10px", color: "#ffffff"
                      }}
                    >
                      Approved
            </span>
                  </TableCell>}

                  {item.Status === 2 && <TableCell>
                    <span
                      style={{
                        cursor: "pointer", backgroundColor: "#dd2735",
                        borderRadius: "5px", padding: "5px 10px", color: "#ffffff"
                      }}
                    >
                      Declined
            </span>
                  </TableCell>}

                </TableRow>
              );
            })}
          </TableBody>
          <TableFooter>
            {/*<RecordPagination fetchMore={fetchPayments} totalCount={totalPaymentCount} pageSize={pageSize} currentPage={currentPage} target={<AirlinesTable/>}/>*/}
            {/*<TableRow />*/}
          </TableFooter>
        </Table>
      </div>
    </div >
  );
}

class ReconciliationTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { classes, reconciliationData, fetchReconciliation,
      totalCount, pageSize, currentPage, filterAirlines, filterUsers,
      filterStatus, approveReconciliation, declineReconciliation,
      openEditModal, closeEditModal, isEditModalOpen,
      handleUpdate, handleChange, newAirlineId, newType, airlines,
      selectAirlineChange, selectTypeChange, newToken, Rate,
      narration, pendingReconId, reconciliationTypes, isCommentModalOpen,
      openCommentModal, closeCommentModal, comment, processName,filterAirport, disabled } = this.props;
    return (
      <div>

        <RecordPagination
          fetchMore={fetchReconciliation}
          totalCount={totalCount}
          pageSize={pageSize}
          currentPage={currentPage}
          target={<ReconciliationTableStructure
            classes={classes}
            reconciliationData={reconciliationData}
            filterAirlines={filterAirlines}
            filterUsers={filterUsers}
            filterStatus={filterStatus}
            approveReconciliation={approveReconciliation}
            declineReconciliation={declineReconciliation}
            openEditModal={openEditModal}
            closeEditModal={closeEditModal}
            isEditModalOpen={isEditModalOpen}
            handleUpdate={handleUpdate}
            handleChange={handleChange}
            newAirlineId={newAirlineId}
            newType={newType}
            airlines={airlines}
            selectAirlineChange={selectAirlineChange}
            selectTypeChange={selectTypeChange}
            newToken={newToken}
            Rate={Rate}
            narration={narration}
            pendingReconId={pendingReconId}
            reconciliationTypes={reconciliationTypes}
            isCommentModalOpen={isCommentModalOpen}
            openCommentModal={openCommentModal}
            closeCommentModal={closeCommentModal}
            comment={comment}
            processName={processName}
            filterAirport= {filterAirport}
            disabled={disabled}
          />} />
      </div>
    );
  }
}

export default (withMobileDialog()(withStyles(styles)(ReconciliationTable)));



// WEBPACK FOOTER //
// ./src/Regional-Views/Reconciliation/ReconciliationTable.jsx